"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventActions_1 = require("./EventActions");
exports.EventAction = EventActions_1.EventAction;
var IframeMessageProxy_1 = require("./IframeMessageProxy");
var instance = IframeMessageProxy_1.IframeMessageProxy.getInstance();
exports.IframeMessageProxy = instance;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQ0FBNEM7QUFJSCxzQkFKaEMsMEJBQVcsQ0FJZ0M7QUFIcEQsMkRBQXlEO0FBRXpELElBQU0sUUFBUSxHQUFHLHVDQUFrQixDQUFDLFdBQVcsRUFBRSxDQUFBO0FBQzVCLHNDQUFrQiJ9